<template>
  <div class="content-430">
    <div class="class-form-head">新增学校考勤确认单</div>
    <Form
      ref="formValidate"
      :model="formValidate"
      label-position="right"
      :label-width="150"
      :rules="validateRule"
    >
      <FormItem label="选择学校：" prop="schoolId">
        <Select
          v-if="theUserIdentity != 'school'"
          filterable
          ref="rschool"
          v-model="formValidate.schoolId"
          style="width: 300px"
          placeholder="选择学校"
        >
          <Option
            v-for="item in schoolList"
            :key="item.schId"
            :label="item.schName"
            :value="item.schId"
          >
          </Option>
        </Select>
        <span>{{ schoolName }}</span>
      </FormItem>
      <FormItem label="当前学期：" prop="yearTerms" :label-width="150">
        <Cascader
          style="width: 300px"
          v-model="formValidate.yearTerms"
          :data="termList"
          :clearable="false"
          placeholder="请选择学期"
        >
        </Cascader>
      </FormItem>
      <FormItem label="所属月份：" prop="yeMonth" :label-width="150">
        <DatePicker
          v-model="formValidate.yeMonth"
          type="month"
          placeholder="请选择月份"
          style="width: 300px"
          :clearable="false"
          :options="limitTime"
        ></DatePicker>
      </FormItem>
      <FormItem label="教师工资生成方式：" prop="ctype" :label-width="150">
        <div class="ex-select" style="width: 500px">
          <div
            :class="{ active: formValidate.ctype == 1 }"
            class="ex-box"
            @click="hadnleTab(1)"
          >
            <span>手动导入</span>
            <span class="mtext"
              >（创建学校考勤确认后，手动导入教师工资条）</span
            >
          </div>
          <div
            :class="{ active: formValidate.ctype == 2 }"
            class="ex-box"
            @click="hadnleTab(2)"
            v-if="false"
          >
            <span>自动生成</span>
            <span class="mtext"
              >（系统根据当月教师考勤签到自动生成教师工资条）</span
            >
          </div>
        </div>
        <div class="tipsfont">
          请根据实际情况，选择合适的学校考勤确认生成方式！
        </div>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >立即生成</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import RemoteSelect from '@c/RemoteSelect';
import { mapGetters } from 'vuex';
import commonApi from '@/request/common/index.js';
import orderApi from '@/request/orderCenter/index.js';
export default {

  components: {
    RemoteSelect
  },
  computed: {
    ...mapGetters(['theUserIdentity', 'userInfo'])
  },
  data() {
    return {
      limitTime: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      },
      formValidate: {
        yearTerms: [],
        ctype: 1,
        schoolId: '',
        yeMonth: null,
      },
      dateStr: '',
      validateRule: {
        schoolId: [
          { required: true, message: '请选择学校', trigger: 'change' }
        ],
        yearTerms: [
          { required: true, message: '请选择学期', trigger: 'change', type: 'array' }
        ],
        yeMonth: [
          { required: true, message: '请选择月份', trigger: 'change', type: 'date' }
        ],
        ctype: [
          { required: true, message: '请选择方式', trigger: 'change', type: 'number' }
        ],
      },
      schoolList: [],//学校列表
      termList: [],
      schoolLoading: false,
      schoolName: ''
    }
  },
  created() {
    if (this.theUserIdentity == 'school') {
      this.formValidate.schoolId = this.userInfo.orgId;
      this.schoolName = this.userInfo.orgName;
    }
    else {
      this.getSchoolList();
    }

    this.getTermList();
  },
  methods: {
    changeSch(e) {
      console.log("e", e)
    },
    handleSubmit(name) {
      console.log("formValidate.yeMonth", this.formValidate)
      this.$refs[name].validate((valid) => {
        if (valid) {
          const nowTime = new Date(this.formValidate.yeMonth);
          const year = nowTime.getFullYear();
          const month = (nowTime.getMonth() + 1) < 10 ? '0' + (nowTime.getMonth() + 1) : (nowTime.getMonth() + 1);
          this.dateStr = `${year}-${month}-01 00:00:00`
          let schoolName = this.schoolName, termsStr;
          for (var i = 0; i < this.schoolList.length; i++) {
            if (this.schoolList[i].schId == this.formValidate.schoolId) {
              schoolName = this.schoolList[i].schName
              break;
            }
          }
          for (var i = 0; i < this.termList.length; i++) {
            if (this.termList[i].value == this.formValidate.yearTerms[0]) {
              for (var j = 0; j < this.termList[i].children.length; j++) {
                if (this.termList[i].children[j].value == this.formValidate.yearTerms[1]) {
                  termsStr = `${this.termList[i].label}学年${this.termList[i].children[j].label}`
                }
              }
              break;
            }
          }
          this.$Modal.confirm({
            title: '提示',
            render: (h, params) => {
              return h("div", [
                h(
                  "p",
                  `是否确定生成【${schoolName}】-【${termsStr}】-【${year}-${month}】的学校考勤确认单？`
                ),
                h(
                  "p",
                  {
                    style: {
                      color: "grey",
                      fontStyle: "italic",
                    },
                  },
                  `生成方式：${this.formValidate.ctype == 1 ? '生成后手动导入' : '自动生成'}`
                ),
                h(
                  "p",
                  {
                    style: {
                      color: "red",
                      fontStyle: "italic",
                      marginTop: "20px"
                    },
                  },
                  `说明：每个【自然月】中，一个学校只能创建、发放一个学校考勤确认单，如需同时补发其他月份的工资，请合并到补发补扣明细中体现！`
                ),
              ]);
            },
            onOk: () => {
              this.createMonthSheetFun();
            }
          });
        } else {
        }
      })
    },
    async createMonthSheetFun() {
      let params = {
        schoolId: this.formValidate.schoolId,
        isNotInit: this.formValidate.ctype == 1 ? true : false,
        yearCode: this.formValidate.yearTerms[0],
        termCode: this.formValidate.yearTerms[1],
        month: this.dateStr
      }
      const res = await orderApi.createMonthSheet(params);
      console.log("rescreateMonthSheetFun", res);
      if (res.data.status === 200) {
        this.$Message.success('操作成功');
        this.$router.go(-1);
      }
    },
    async getTermList() {
      const res = await commonApi.getYearTermDict();
      if (res.status === 200) {
        const termList = [];
        res.message.map((item) => {
          let obj = {};
          obj.value = item.yearCode;
          obj.label = item.yearName;
          let childAr = [];
          item.termList.map((child) => {
            let citem = {};
            citem.value = child.termCode;
            citem.label = child.termName;
            childAr.push(citem);
          })
          obj.children = childAr;
          termList.push(obj);
        });
        this.termList = termList;
      }
    },
    //学校列表
    getSchoolList(query) {
      query ? (this.schoolLoading = true) : '';
      const queryTrue = query && query.length === 1 ? '' : query;
      this.schByOpe(queryTrue);
    },
    hadnleTab(v) {
      this.formValidate.ctype = v;
    },
    loadAllList(val) {
      if (!val) {
        this.getSchoolList('');
      }
    },
    async schByOpe(query) {
      const res = await orderApi.findSchList({});
      if (res.status === 200) {
        this.schoolList = res.message;
        this.schoolLoading = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.class-form-head {
  background: rgba(0, 0, 0, 0.05);
  padding: 16px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 24px;
}

.ex-select {
  display: flex;
  text-align: center;
  justify-content: start;
  margin-bottom: 20px;

  .ex-box {
    display: flex;
    flex-direction: column;
    width: 200px;
    height: 90px;
    padding-top: 5px;
    border-radius: 10px;
    margin-right: 20px;
    background: #eeeeee;
    cursor: pointer;

    .mtext {
      color: #c5c8ce;
      line-height: 22px;
    }
  }

  .active {
    background: #488ffa;
    color: #fff;
  }
}

.tipsfont {
  color: red;
  font-size: 14px;
}

.count-main {
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 28px;
  width: 100%;
  margin: 20px 0;
}
</style>